import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EmployComponent } from "./employ.component";


const routes: Routes = [
  {
    path: 'employ',
    component: EmployComponent,
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EmployRoutingModule { }
